import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { INFRASTRUCTURE_PAGE_SLUG } from '../utils/infrastructurePageSlug';

export const useInfrastructureSectionContent = (parser) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const page = await getPublicPage(INFRASTRUCTURE_PAGE_SLUG);
        if (!isMounted) {
          return;
        }

        setContent(parser(page));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [parser]);

  return { content, isLoading, error };
};
